import { render, staticRenderFns } from "./FormatGeneral.vue?vue&type=template&id=4c414126&scoped=true"
import script from "./FormatGeneral.vue?vue&type=script&lang=js"
export * from "./FormatGeneral.vue?vue&type=script&lang=js"
import style0 from "./FormatGeneral.vue?vue&type=style&index=0&id=4c414126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c414126",
  null
  
)

export default component.exports